import { Check } from 'lucide-react';
import { useToastSubscription } from '@/lib/toast';

export default function ToastContainer() {
  const toasts = useToastSubscription();
  const isDark = typeof document !== 'undefined' && document.documentElement.classList.contains('dark');

  return (
    <div className="fixed top-4 right-4 z-50 space-y-3">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-center space-x-2 px-4 py-3 rounded-lg shadow-xl backdrop-blur-sm animate-slide-in w-72 sm:w-80 border border-green-400/30 ${
            isDark ? 'bg-green-600/90 text-white' : 'bg-green-500/90 text-white'
          }`}
        >
          <Check className="w-5 h-5 flex-shrink-0" />
          <span className="text-sm font-medium truncate">{toast.message}</span>
        </div>
      ))}
    </div>
  );
} 